import imageFormat from "./type/definition/imageFormat.js";
import animation from "./type/definition/animation.js"
import imageRotation from "./type/definition/rotation.js"

export default [
    // {
    //     id: "default_paysage",
    //     enable: true,
    //     name: "Composition paysage",
    //     printPapers: [
    //         "_4x6_GLOSSY",
    //         "_4x6_MAT"
    //     ],
    //     thumbnail: {
    //         objectType: "ImageElement",
    //         path: "@cadre_paysage_demo@",
    //         format: imageFormat.Ajuster,
    //         animation: animation.WOW_LEFT,
    //         pressAnimation : animation.ZOOM_IN,
    //     },
    //     liveTimeout: 60,
    //     live: {
    //         position: {
    //             x: 20,
    //             y: 20,
    //             size: {
    //                 largeur: 1040,
    //                 hauteur: 1880,
    //             },
    //         },
    //         canAddElement: false,
    //         contain: [{
    //             objectType: "DynamicImage",
    //             canBeRemove: false,
    //             animation: animation.OPACITY,
    //             pressAnimation: animation.NONE,
    //             format: imageFormat.Ajuster,
    //             rotation: imageRotation.RotateNoneFlipX
    //         }]
    //     },
    //     build: {
    //         size: {
    //             width: 1950,
    //             height: 1300,
    //         },
    //         plans: [
    //             {
    //                 objectType: "CameraPlanItem",
    //                 position: {
    //                     x: 79,
    //                     y: 79,
    //                     size: {
    //                         largeur: 1792,
    //                         hauteur: 1062,
    //                     },
    //                 },
    //                 format: imageFormat.Rempli,
    //                 rotation: imageRotation.RotateNoneFlipX,
    //                 cameraId: 0,
    //                 triggerOrder: 0,
    //                 triggerDelay: 0,
    //             },
    //             {
    //                 objectType: "ImagePlanItem",
    //                 position: {
    //                     x: 0,
    //                     y: 0,
    //                     size: {
    //                         largeur: 1950,
    //                         hauteur: 1300,
    //                     },
    //                 },
    //                 format: imageFormat.Etirer,
    //                 rotation: imageRotation.None,
    //                 path: "@cadre_paysage@",
    //             },
    //             {
    //                 objectType: "TextPlanItem",
    //                 position: {
    //                     x: 0,
    //                     y: 1140,
    //                     size: {
    //                         largeur: 1950,
    //                         hauteur: 140,
    //                     },
    //                 },
    //                 format: imageFormat.Rempli,
    //                 rotation: imageRotation.None,
    //                 text: "@print_text@",
    //                 textColor: "#FF0000",
    //                 textShadowColor: "#980000",
    //                 textShadowOffsetX: 0,
    //                 textShadowOffsetY: 0,
    //                 textShadowStrokeWidth: 0,
    //                 textPolice: "Great Vibes",
    //                 textFontSize: 58,
    //                 textFontStyle: "Regular",
    //                 textAlignment: "Center",
    //             }   
    //         ]
    //     }
    // },
    // {
    //     id: "default_triple_portrait",
    //     enable: true,
    //     name: "Composition paysage : triple portrait",
    //     printPapers: [
    //         "_4x6_GLOSSY",
    //         "_4x6_MAT"
    //     ],
    //     thumbnail: {
    //         objectType: "ImageElement",
    //         path: "@cadre_triple_demo@",
    //         format: imageFormat.Ajuster,
    //         animation: animation.WOW_LEFT,
    //         pressAnimation : animation.ZOOM_IN,
    //     },
    //     liveTimeout: 60,
    //     live: {
    //         position: {
    //             x: 20,
    //             y: 20,
    //             size: {
    //                 largeur: 1040,
    //                 hauteur: 1880,
    //             },
    //         },
    //         canAddElement: false,
    //         contain: [{
    //             objectType: "DynamicImage",
    //             canBeRemove: false,
    //             animation: animation.OPACITY,
    //             pressAnimation: animation.NONE,
    //             format: imageFormat.Ajuster,
    //             rotation: imageRotation.RotateNoneFlipX
    //         }]
    //     },
    //     build: {
    //         size: {
    //             width: 1950,
    //             height: 1300,
    //         },
    //         plans: []
    //     }
    // },
    // {
    //     id: "default_portrait",
    //     enable: true,
    //     name: "Composition portrait",
    //     printPapers: [
    //         "_4x6_GLOSSY",
    //         "_4x6_MAT"
    //     ],
    //     thumbnail: {
    //         objectType: "ImageElement",
    //         path: "@cadre_portrait_demo@",
    //         format: imageFormat.Ajuster,
    //         animation: animation.WOW_LEFT,
    //         pressAnimation : animation.ZOOM_IN,
    //     },
    //     liveTimeout: 60,
    //     live: {
    //         position: {
    //             x: 20,
    //             y: 20,
    //             size: {
    //                 largeur: 1040,
    //                 hauteur: 1880,
    //             },
    //         },
    //         canAddElement: false,
    //         contain: [{
    //             objectType: "DynamicImage",
    //             canBeRemove: false,
    //             animation: animation.OPACITY,
    //             pressAnimation: animation.NONE,
    //             format: imageFormat.Ajuster,
    //             rotation: imageRotation.RotateNoneFlipX
    //         }]
    //     },
    //     build: {
    //         size: {
    //             width: 1950,
    //             height: 1300,
    //         },
    //         plans: []
    //     }
    // },
]
